import { Helmet } from 'react-helmet-async';
import { useSiteData } from '@/hooks/useSiteData';

import { Layout } from '@/components/layout/Layout';
import { Hero } from '@/components/sections/Hero';
import { AboutTheClub } from '@/components/sections/AboutTheClub';
import { MembershipCTA } from '@/components/sections/MembershipCTA';
import { ClubClothingAnnouncement } from '@/components/sections/ClubClothingAnnouncement';
import { InfoSection } from '@/components/sections/InfoSection';
import { useContactData } from '@/hooks/useContactData';
import { useNavigationData } from '@/hooks/useNavigationData';
import { useHomepageData } from '@/hooks/useHomepageData';

export function Index() {
  const { siteData } = useSiteData();
  const { contactInfo } = useContactData();
  const { navigationItems } = useNavigationData();
  const { pageData } = useHomepageData();

  return (
    <>
      <Helmet>
        <title>{siteData.title}</title>
        <meta name="description" content={siteData.description} />
        <meta name="keywords" content={siteData.keywords} />
      </Helmet>

      <Layout contactInfo={contactInfo} navigationItems={navigationItems}>
        <div className="p-4 sm:p-8 space-y-6 sm:space-y-12 max-w-4xl mx-auto">
          <Hero />

          <AboutTheClub />

          <MembershipCTA
            isAccepting={pageData.membershipInfo.isAccepting}
            requirements={pageData.membershipInfo.requirements}
          />

          <ClubClothingAnnouncement />
          
          {pageData.links.map((linkSection, index) => (
            <InfoSection
              key={index}
              title={linkSection.title}
              items={linkSection.items}
            />
          ))}
        </div>
      </Layout>
    </>
  );
}